export const events = [
  // --- US FEDERAL & MAJOR HOLIDAYS ---
  { date: "2026-01-01", title: "New Year's Day", category: "us" },
  { date: "2026-01-19", title: "Martin Luther King, Jr. Day", category: "us" },
  { date: "2026-02-16", title: "Washington's Birthday", category: "us" },
  { date: "2026-05-25", title: "Memorial Day", category: "us" },
  { date: "2026-06-19", title: "Juneteenth", category: "us" },
  { date: "2026-07-04", title: "Independence Day", category: "us" },
  { date: "2026-09-07", title: "Labor Day", category: "us" },
  { date: "2026-10-12", title: "Columbus Day", category: "us" },
  { date: "2026-11-11", title: "Veterans Day", category: "us" },
  { date: "2026-11-26", title: "Thanksgiving Day", category: "us" },
  { date: "2026-12-25", title: "Christmas Day", category: "us" },

  // --- INDONESIAN HOLIDAYS & NATIONAL DAYS ---
  { date: "2026-02-17", title: "Tahun Baru Imlek 2577", category: "indo" },
  { date: "2026-02-17", title: "🙏 Seven Holy Founders of the Servite Order (Memorial)", category: "special", saintDetails: {
    name: "Seven Holy Founders of the Servite Order (St. Alexis Falconieri)",
    origin: "Florence, Italy (13th Century)",
    patronage: "Servite Order, Florence",
    symbols: "Seven Lilies, Sorrows of Mary",
    image: "/assets/generated/saint_2026_02_17.png",
    bio: "Seven noblemen of Florence (led by St. Alexis Falconieri) who withdrew from the world to live a life of prayer and service, eventually founding the Order of Friar Servants of Mary."
  }},
  { date: "2026-02-17", title: "🍳 Recipe: Thai Coastal Large Eggs", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Thai Coastal Nueng Manao (Large Eggs)",
    link: "resep/Thai_Coastal_Eggs_Feb_17.md",
    name: "Thai Coastal Large Eggs",
    image: "/assets/generated/recipe_2026_02_17.png",
    cuisine: "Thai Coastal",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-17", title: "📖 Story: The Fisherman and His Wife", category: "special", storyDetails: {
    name: "The Fisherman and His Wife",
    genre: "General Folklore",
    image: "/assets/generated/story_2026_02_17.png"
  }},
  { date: "2026-02-17", title: "🌙 Ramadan Starts (Est)", category: "indo" },
  { date: "2026-02-18", title: "⛪ Ash Wednesday (Lent Begins)", category: "special" },
  { date: "2026-02-18", title: "🙏 St. Bernadette Soubirous (Memorial)", category: "special", saintDetails: {
    name: "St. Bernadette Soubirous (Our Lady of Lourdes)",
    origin: "Lourdes, France (1844–1879 AD)",
    patronage: "Lourdes, Sick People, Shepherds",
    symbols: "Rosary, Grotto, Spring, Blue Sash",
    image: "/assets/generated/saint_2026_02_18.png",
    bio: "On February 18, 1858, the 'Lady in White' spoke for the first time to Bernadette Soubirous at the Grotto of Massabielle. The young shepherdess saw the 'Immaculate Conception' 18 times, revealing a spring of healing water and a message of prayer and penance that transformed Lourdes into a global sanctuary of healing."
  }},
  { date: "2026-02-18", title: "🍳 Recipe: Modern American Tofu", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Modern American Pan-Roasted Tofu with Carrots",
    link: "resep/Modern_American_Tofu_Feb_18.md",
    name: "Modern American Tofu",
    image: "/assets/generated/recipe_2026_02_18.png",
    cuisine: "Modern American",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-18", title: "📖 Story: The Frog Prince", category: "special", storyDetails: {
    name: "The Frog Prince",
    genre: "General Folklore",
    image: "/assets/generated/story_2026_02_18.png"
  }},
  { date: "2026-02-19", title: "🙏 St. Conrad of Piacenza (Memorial)", category: "special", saintDetails: {
    name: "St. Conrad of Piacenza",
    origin: "Piacenza, Italy (1290–1351 AD)",
    patronage: "Hernia Sufferers, Noto, Piacenza",
    symbols: "Hermit's Habit, Crucifix, Bread, Fire",
    image: "/assets/generated/saint_2026_02_19.png",
    bio: "A nobleman who accidentally started a wildfire while hunting. After an innocent man was condemned for it, Conrad confessed, sold all he owned to pay for the damage, and became a Franciscan hermit. He spent his remaining 40 years in prayer and penance in a cave in Sicily."
  }},
  { date: "2026-02-19", title: "🍳 Recipe: Cantonese Modern Salmon", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Cantonese Modern Qing Zheng Salmon with Russet Potatoes",
    link: "resep/Cantonese_Modern_Salmon_Feb_19.md",
    name: "Cantonese Modern Salmon",
    image: "/assets/generated/recipe_2026_02_19.png",
    cuisine: "Cantonese Modern",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-19", title: "📖 Story: The Goose Girl", category: "special", storyDetails: {
    name: "The Goose Girl",
    genre: "General Folklore",
    image: "/assets/generated/story_2026_02_19.png"
  }},
  { date: "2026-02-20", title: "🙏 Saints Francisco and Jacinta Marto (Memorial)", category: "special", saintDetails: {
    name: "Saints Francisco and Jacinta Marto (The Visionaries of Fatima)",
    origin: "Aljustrel, Portugal (1908–1919/1920 AD)",
    patronage: "Young People, Sick People, Prisoners",
    symbols: "Staff, Rosary, Lamb, The Immaculate Heart",
    image: "/assets/generated/saint_2026_02_20.png",
    bio: "Saints Francisco and Jacinta Marto were the youngest non-martyr saints to be canonized. In 1917, they witnessed a series of apparitions of the Virgin Mary at the Cova da Iria in Fatima, Portugal. Known for their deep devotion and sacrifice, they spent their short lives in intense prayer for the world. They were canonized by Pope Francis in 2017 on the centenary of the first apparition."
  }},
  { date: "2026-02-20", title: "🍳 Recipe: Japanese Kaiseki Cod", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Japanese Kaiseki Saikyo-yaki Cod with Carrots",
    link: "resep/Japanese_Kaiseki_Cod_Feb_20.md",
    name: "Japanese Kaiseki Cod",
    image: "/assets/generated/recipe_2026_02_20.png",
    cuisine: "Japanese Kaiseki",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-20", title: "📖 Story: The Brave Little Tailor", category: "special", storyDetails: {
    name: "The Brave Little Tailor",
    genre: "General Folklore",
    image: "/assets/generated/story_2026_02_20.png"
  }},
  { date: "2026-03-19", title: "Hari Suci Nyepi (Saka 1948)", category: "indo" },
  { date: "2026-03-21", title: "Hari Raya Idul Fitri 1447H", category: "indo" },
  { date: "2026-03-22", title: "Hari Raya Idul Fitri (Hari 2)", category: "indo" },
  { date: "2026-04-03", title: "Wafat Isa Al Masih (Good Friday)", category: "indo" },
  { date: "2026-04-05", title: "Hari Paskah (Easter Sunday)", category: "indo" },
  { date: "2026-05-01", title: "Hari Buruh Internasional", category: "indo" },
  { date: "2026-05-14", title: "Kenaikan Isa Al Masih", category: "indo" },
  { date: "2026-05-27", title: "Hari Raya Idul Adha 1447H", category: "indo" },
  { date: "2026-05-31", title: "Hari Raya Waisak 2570", category: "indo" },
  { date: "2026-06-01", title: "Hari Lahir Pancasila", category: "indo" },
  { date: "2026-06-16", title: "Tahun Baru Islam 1448H", category: "indo" },
  { date: "2026-08-17", title: "Hari Kemerdekaan RI", category: "indo" },
  { date: "2026-08-25", title: "Maulid Nabi Muhammad SAW", category: "indo" },
  { date: "2026-10-02", title: "🇮🇩 Hari Batik Nasional", category: "indo" },
  { date: "2026-10-28", title: "🇮🇩 Hari Sumpah Pemuda", category: "indo" },
  { date: "2026-11-10", title: "🇮🇩 Hari Pahlawan", category: "indo" },
  { date: "2026-12-22", title: "🇮🇩 Hari Ibu", category: "indo" },
  { date: "2026-12-25", title: "Hari Raya Natal", category: "indo" },

  // --- FUN, CULTURE & ENTERTAINMENT ---
  { date: "2026-02-05", title: "🙏 St. Agatha (Memorial)", category: "special", saintDetails: {
    name: "Saint Agatha",
    origin: "Catania, Sicily (3rd Century)",
    patronage: "Breast Cancer, Fire, Nurses",
    symbols: "Palm Frond, Shears, Platter",
    image: "/assets/generated/saint_agatha_portrait.png",
    bio: "Virgin and martyr who survived brutal torture for her faith. Patron against fire and breast cancer."
  }},
  { date: "2026-02-14", title: "❤️ Valentine's Day", category: "fun" },
  { date: "2026-02-17", title: "🎭 Mardi Gras", category: "fun" },
  { date: "2026-03-15", title: "🏆 The Oscars (98th Academy Awards)", category: "fun" },
  { date: "2026-03-17", title: "☘️ St. Patrick's Day", category: "fun" },
  { date: "2026-04-10", title: "🎡 Coachella (Weekend 1)", category: "fun" },
  { date: "2026-04-17", title: "🎡 Coachella (Weekend 2)", category: "fun" },
  { date: "2026-05-04", title: "👗 Met Gala 2026", category: "fun" },
  { date: "2026-05-10", title: "💐 Mother's Day (USA)", category: "fun" },
  { date: "2026-06-21", title: "👔 Father's Day (USA)", category: "fun" },
  { date: "2026-09-19", title: "🍺 Oktoberfest Begins (Munich)", category: "fun" },
  { date: "2026-10-31", title: "🎃 Halloween", category: "fun" },
  { date: "2026-11-27", title: "🛍️ Black Friday", category: "special" },

  // --- SPORTS: WORLD CUP, SUPER BOWL, F1, MOTOGP, TENNIS ---
  { date: "2026-02-06", title: "🙏 St. Paul Miki & Companions (Memorial)", category: "special", saintDetails: {
    name: "Saints Paul Miki & Companions",
    origin: "Nagasaki, Japan (1597 AD)",
    patronage: "Japan, Missionaries",
    symbols: "Cross, Spear, Palm of Victory",
    image: "/assets/generated/st_paul_miki_portrait.png",
    bio: "A group of 26 martyrs crucified in Nagasaki. Paul Miki, a Jesuit preacher, famously forgave his executioners while hanging on his cross."
  }},
  { date: "2026-02-06", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "Daily Analysis: Feb 6, 2026",
    link: "trading/2026-02-06-plan.md"
  }},
  { date: "2026-02-07", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "Weekend Outlook: Feb 7, 2026",
    link: "trading/2026-02-07-plan.md"
  }},
  { date: "2026-02-07", title: "🙏 St. Moses the Hermit (Memorial)", category: "special", contentScript: {
    title: "The Garlic Lie: Fresh vs. Jarred (Science Explained)",
    source: "Ethan Chlebowski",
    summary: "Ethan Chlebowski explains why jarred garlic is chemically inferior due to lack of Allicin.",
    script: "**Hook:** You think you're saving time, but you're ruining your food. Jarred garlic isn't just 'worse'—it's chemically a different ingredient.\n\n**The Science of Allicin:** Garlic flavor doesn't exist until you crush it. It's a binary weapon. Damage the cell, and the enzyme *alliinase* meets *alliin* to create **Allicin**. That's the punch, the heat, the 'garlic' taste.\n\n**Why Jars Fail:**\n1. **Time:** Allicin degrades in minutes. Jarred garlic is dead garlic.\n2. **Acid:** To keep botulism away, jars are acidified (citric/phosphoric acid). This permanently destroys the enzyme. You can never get fresh flavor back.\n\n**The Taste Test:** Fresh is spicy and pungent. Jarred is sour, metallic, and weak.\n\n**The Fix:** Buy a rasp grater (Microplane). Fresh garlic in 10 seconds. No excuses."
  }, saintDetails: {
    name: "Saint Moses of Sinai",
    origin: "Egypt/Sinai (4th Century)",
    patronage: "Desert Monasticism, Peace",
    symbols: "Staff, Cave, Desert",
    image: "/assets/generated/st_moses_portrait.png",
    bio: "An Egyptian monk who lived as a hermit in the Sinai desert. He is remembered for his extreme asceticism and for leading his followers in peace."
  }},
  { date: "2026-02-08", title: "🙏 St. Josephine Bakhita (Memorial)", category: "special", saintDetails: {
    name: "Saint Josephine Bakhita",
    origin: "Sudan/Italy (19th Century)",
    patronage: "Human Trafficking, Sudan",
    symbols: "Broken Chains, Canossian Habit",
    image: "/assets/generated/saint_2026_02_08.png",
    bio: "Born in Sudan and kidnapped into slavery at a young age, Bakhita eventually found freedom in Italy. She became a Canossian Sister and is a powerful symbol of hope and forgiveness."
  }},
  { date: "2026-02-08", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "Sunday Analysis: Feb 8, 2026",
    link: "trading/2026-02-08-plan.md"
  }},
  { date: "2026-02-09", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "Weekly Open: Feb 9, 2026",
    link: "trading/2026-02-09-plan.md"
  }},
  { date: "2026-02-10", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "Profit Protection: Feb 10, 2026",
    link: "trading/2026-02-10-plan.md"
  }},
  { date: "2026-02-10", title: "🍳 Recipe: Saikyo-yaki Cod (Improved)", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Saikyo-yaki Cod with Micro-Radish",
    link: "resep/Improved_Saikyo_Cod_Feb_10.md",
    name: "Saikyo-yaki Cod (Improved)",
    cuisine: "Japanese Kaiseki",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-10", title: "🙏 St. Scholastica (Memorial)", category: "special", saintDetails: {
    name: "Saint Scholastica",
    origin: "Nursia, Italy (5th Century)",
    patronage: "Nuns, Storms, Books",
    symbols: "Dove, Book, Crozier with Lily",
    image: "/assets/generated/saint_2026_02_10.png",
    bio: "The twin sister of Saint Benedict and the first Benedictine nun. Known for the miraculous thunderstorm she prayed for so she could spend one last night in spiritual conversation with her brother before her death."
  }},
  { date: "2026-02-13", title: "🙏 St. Catherine de Ricci (Memorial)", category: "special", saintDetails: {
    name: "Saint Catherine de Ricci",
    origin: "Prato, Italy (16th Century)",
    patronage: "Sick People, Tobaccoists",
    symbols: "Crucifix, Ring, Crown of Thorns",
    image: "/assets/generated/saint_2026_02_13.svg",
    bio: "Italian Dominican nun and mystic. She experienced the 'Ecstasy of the Passion' weekly for 12 years. Known for her spiritual wisdom and leadership."
  }},
  { date: "2026-02-13", title: "🍳 Recipe: Modern American Tofu", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Modern American Tofu with Green Garlic Oil",
    link: "resep/Modern_American_Tofu_Feb_13.md",
    name: "Modern American Tofu (Optimized)",
    image: "/assets/generated/recipe_2026_02_13.svg",
    cuisine: "Modern American",
    level: "Michelin Executive Standard"
  }},
  { date: "2026-02-13", title: "📈 Trading Plan: BTC/ETH/SOL", category: "market", tradingDetails: {
    title: "The Great Plunge: Feb 13, 2026",
    link: "trading/2026-02-13-plan.md"
  }},
  { date: "2026-02-09", title: "🙏 St. Apollonia (Memorial)", category: "special", saintDetails: {
    name: "Saint Apollonia",
    origin: "Alexandria, Egypt (3rd Century)",
    patronage: "Dentists, Toothaches",
    symbols: "Pincers, Tooth, Martyr's Palm",
    image: "/assets/generated/saint_2026_02_09.png",
    bio: "Elderly Christian deaconess martyred in Alexandria. After her teeth were violently removed, she bravely leapt into the fire rather than renounce her faith."
  }},
  { date: "2026-02-09", title: "🍳 Recipe: Cantonese Modern Salmon", category: "meals", recipeDetails: {
    title: "Voss-Valmont Optimized: Cantonese Modern Salmon",
    link: "/resep/Improved Cantonese Modern Salmon Feb 9.md",
    name: "Cantonese Modern Salmon (Optimized)",
    cuisine: "Cantonese Modern",
    level: "Voss-Valmont Protocol"
  }},
  { date: "2026-02-08", title: "🏈 Super Bowl LX", category: "sports" },
  { date: "2026-06-11", title: "⚽ FIFA World Cup 2026 Opening", category: "sports" },
  { date: "2026-07-19", title: "⚽ FIFA World Cup 2026 Final (NJ)", category: "sports" },

  // F1 2026
  { date: "2026-03-08", title: "🏎️ F1 Australian GP", time: "00:00 AM CT", category: "sports" },
  { date: "2026-03-15", title: "🏎️ F1 Chinese GP", time: "02:00 AM CT", category: "sports" },
  { date: "2026-03-29", title: "🏎️ F1 Japanese GP", time: "00:00 AM CT", category: "sports" },
  { date: "2026-04-12", title: "🏎️ F1 Bahrain GP", time: "09:00 AM CT", category: "sports" },
  { date: "2026-04-19", title: "🏎️ F1 Saudi Arabian GP", time: "11:00 AM CT", category: "sports" },
  { date: "2026-05-03", title: "🏎️ F1 Miami GP", time: "02:30 PM CT", category: "sports" },
  { date: "2026-05-24", title: "🏎️ F1 Canadian GP", time: "01:00 PM CT", category: "sports" },
  { date: "2026-06-07", title: "🏎️ F1 Monaco GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-06-14", title: "🏎️ F1 Spanish GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-06-28", title: "🏎️ F1 Austrian GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-07-05", title: "🏎️ F1 British GP", time: "09:00 AM CT", category: "sports" },
  { date: "2026-07-19", title: "🏎️ F1 Belgian GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-07-26", title: "🏎️ F1 Hungarian GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-08-23", title: "🏎️ F1 Dutch GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-09-06", title: "🏎️ F1 Italian GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-09-13", title: "🏎️ F1 Madrid GP", time: "08:00 AM CT", category: "sports" },
  { date: "2026-09-26", title: "🏎️ F1 Azerbaijan GP", time: "06:00 AM CT", category: "sports" },
  { date: "2026-10-11", title: "🏎️ F1 Singapore GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-10-25", title: "🏎️ F1 United States GP", time: "02:00 PM CT", category: "sports" },
  { date: "2026-11-01", title: "🏎️ F1 Mexican GP", time: "02:00 PM CT", category: "sports" },
  { date: "2026-11-08", title: "🏎️ F1 São Paulo GP", time: "11:00 AM CT", category: "sports" },
  { date: "2026-11-21", title: "🏎️ F1 Las Vegas GP", time: "00:00 AM CT", category: "sports" },
  { date: "2026-11-29", title: "🏎️ F1 Qatar GP", time: "11:00 AM CT", category: "sports" },
  { date: "2026-12-06", title: "🏎️ F1 Abu Dhabi GP", time: "07:00 AM CT", category: "sports" },

  // MotoGP 2026
  { date: "2026-03-01", title: "🏍️ MotoGP Thai GP", time: "03:00 AM CT", category: "sports" },
  { date: "2026-03-22", title: "🏍️ MotoGP Brazilian GP", time: "11:00 AM CT", category: "sports" },
  { date: "2026-03-29", title: "🏍️ MotoGP Americas GP", time: "02:00 PM CT", category: "sports" },
  { date: "2026-04-12", title: "🏍️ MotoGP Qatar GP", time: "11:00 AM CT", category: "sports" },
  { date: "2026-04-26", title: "🏍️ MotoGP Spanish GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-05-10", title: "🏍️ MotoGP French GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-05-17", title: "🏍️ MotoGP Catalan GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-05-31", title: "🏍️ MotoGP Italian GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-06-07", title: "🏍️ MotoGP Hungarian GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-06-21", title: "🏍️ MotoGP Czech GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-06-28", title: "🏍️ MotoGP Dutch GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-07-12", title: "🏍️ MotoGP German GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-08-09", title: "🏍️ MotoGP British GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-08-30", title: "🏍️ MotoGP Aragon GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-09-13", title: "🏍️ MotoGP San Marino GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-09-20", title: "🏍️ MotoGP Austrian GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-10-04", title: "🏍️ MotoGP Japanese GP", time: "00:00 AM CT", category: "sports" },
  { date: "2026-10-11", title: "🏍️ MotoGP Mandalika (Indo)", time: "02:00 AM CT", category: "sports" },
  { date: "2026-10-25", title: "🏍️ MotoGP Australian GP", time: "10:00 PM CT", category: "sports" },
  { date: "2026-11-01", title: "🏍️ MotoGP Malaysian GP", time: "02:00 AM CT", category: "sports" },
  { date: "2026-11-15", title: "🏍️ MotoGP Portuguese GP", time: "07:00 AM CT", category: "sports" },
  { date: "2026-11-22", title: "🏍️ MotoGP Valencian GP", time: "07:00 AM CT", category: "sports" },

  // Tennis Finals
  { date: "2026-01-31", title: "🎾 Aus Open Final (W)", time: "02:30 AM CT", category: "sports" },
  { date: "2026-02-01", title: "🎾 Aus Open Final (M)", time: "02:30 AM CT", category: "sports" },
  { date: "2026-06-06", title: "🎾 French Open Final (W)", time: "08:00 AM CT", category: "sports" },
  { date: "2026-06-07", title: "🎾 French Open Final (M)", time: "08:00 AM CT", category: "sports" },
  { date: "2026-07-11", title: "🎾 Wimbledon Final (W)", time: "08:00 AM CT", category: "sports" },
  { date: "2026-07-12", title: "🎾 Wimbledon Final (M)", time: "08:00 AM CT", category: "sports" },
  { date: "2026-09-12", title: "🎾 US Open Final (W)", time: "03:00 PM CT", category: "sports" },
  { date: "2026-09-13", title: "🎾 US Open Final (M)", time: "03:00 PM CT", category: "sports" },

  // --- MARKET, ECONOMY & CRYPTO ---
  { date: "2026-01-28", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-03-18", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-04-29", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-06-17", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-07-29", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-09-16", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-10-28", title: "🏦 FOMC Rate Decision", category: "market" },
  { date: "2026-12-09", title: "🏦 FOMC Rate Decision", category: "market" },

  { date: "2026-01-13", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-02-11", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-03-11", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-04-10", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-05-12", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-06-10", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-07-14", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-08-12", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-09-11", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-10-14", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-11-10", title: "📊 US CPI Inflation Data", category: "market" },
  { date: "2026-12-10", title: "📊 US CPI Inflation Data", category: "market" },

  { date: "2026-01-19", title: "🌍 WEF Davos Meeting Starts", category: "market" },
  { date: "2026-12-14", title: "🌍 G20 Summit (Miami)", category: "market" },
  { date: "2026-04-27", title: "₿ Bitcoin 2026 (Vegas)", category: "market" },
  { date: "2026-05-05", title: "₿ Consensus 2026 (Miami)", category: "market" },
  { date: "2026-11-03", title: "Ξ Ethereum Devcon 8", category: "market" },
  { date: "2026-11-15", title: "◎ Solana Breakpoint", category: "market" },

  // --- KANSAS STATE UNIVERSITY (K-STATE) ---
  { date: "2026-01-20", title: "🟣 K-State Spring Classes Begin", category: "kansas" },
  { date: "2026-03-16", title: "🟣 K-State Spring Break Starts", category: "kansas" },
  { date: "2026-04-18", title: "🟣 K-State Open House (Manhattan)", category: "kansas" },
  { date: "2026-05-16", title: "🟣 K-State Commencement", category: "kansas" },
  { date: "2026-08-24", title: "🟣 K-State Fall Classes Begin", category: "kansas" },
  { date: "2026-11-23", title: "🟣 K-State Thanksgiving Break", category: "kansas" },
  { date: "2026-12-19", title: "🟣 K-State Fall Commencement", category: "kansas" },

  // --- FINANCE & TAX DEADLINES ---
  { date: "2026-03-16", title: "💼 Business Tax Filing Deadline", category: "finance" },
  { date: "2026-03-31", title: "🇮🇩 Deadline SPT Pribadi Indonesia", category: "finance" },
  { date: "2026-04-15", title: "💸 US Federal Tax Day", category: "finance" },
  { date: "2026-04-30", title: "🇮🇩 Deadline SPT Badan Indonesia", category: "finance" },
  { date: "2026-05-11", title: "🏠 KS Property Tax (2nd Half) Due", category: "finance" },
  { date: "2026-09-01", title: "⚖️ KS Tax Sale Eligibility Date", category: "finance" },
  { date: "2026-09-30", title: "🇮🇩 Jatuh Tempo PBB-P2", category: "finance" },
  { date: "2026-12-21", title: "🏠 KS Property Tax (1st Half) Due", category: "finance" },

  // --- NATURE, WEATHER & ASTRONOMY ---
  { date: "2026-03-20", title: "🌸 Spring Equinox", category: "special" },
  { date: "2026-06-21", title: "☀️ Summer Solstice", category: "special" },
  { date: "2026-09-22", title: "🍂 Autumn Equinox", category: "special" },
  { date: "2026-12-21", title: "❄️ Winter Solstice", category: "special" },
  { date: "2026-08-12", title: "🌑 Total Solar Eclipse (Europe)", category: "nature" },
  { date: "2026-08-12", title: "🌠 Perseids Meteor Peak", category: "nature" },
  { date: "2026-12-13", title: "🌠 Geminids Meteor Peak", category: "nature" },
  { date: "2026-04-15", title: "🌪️ Peak Tornado Season Begins (KS)", category: "kansas" },
  { date: "2026-06-15", title: "🌪️ Peak Tornado Season Ends (KS)", category: "kansas" },

  // Full Moon Calendar 2026
  { date: "2026-01-03", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-02-01", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-03-03", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-04-01", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-05-01", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-05-31", title: "🌕 Blue Moon", category: "nature" },
  { date: "2026-06-29", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-07-29", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-08-27", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-09-26", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-10-25", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-11-24", title: "🌕 Full Moon", category: "nature" },
  { date: "2026-12-23", title: "🌕 Full Moon", category: "nature" },

  // --- PERSONAL BIRTHDAYS ---
  { date: "2026-03-25", title: "🎂 My Birthday", category: "personal" },
  { date: "2026-10-25", title: "🎂 Ultah Adek", category: "personal" },
  { date: "2026-11-08", title: "🎂 Ultah Liliana", category: "personal" },

  // --- GARDENING & SHIITAKE (ZONE 6A) ---
  { date: "2026-03-10", title: "🍄 Shiitake: Source Fresh Logs", category: "gardening" },
  { date: "2026-03-20", title: "🍄 Shiitake: Log Inoculation Day", category: "gardening" },
  { date: "2026-04-05", title: "🍄 Shiitake: Start Spawn Run (Shade)", category: "gardening" },
  { date: "2026-09-15", title: "🍄 Shiitake: First Flush (Shock)", category: "gardening" },
  { date: "2026-10-15", title: "🍄 Shiitake: Second Flush Window", category: "gardening" },

  // Seeding/Planting Schedule
  { date: "2026-02-15", title: "🌱 Seed: Scallions & Leeks (In)", category: "gardening" },
  { date: "2026-03-01", title: "🌱 Seed: Ginger (Indoor Heat Mat)", category: "gardening" },
  { date: "2026-03-05", title: "🌱 Seed: Spinach & Peas (Dir)", category: "gardening" },
  { date: "2026-03-17", title: "🥔 Plant: Russet Potatoes", category: "gardening" },
  { date: "2026-03-25", title: "🍅 Seed: Tomatoes (Indoors)", category: "gardening" },
  { date: "2026-04-01", title: "🌱 Start Mowing Lawn (Est)", category: "gardening" },
  { date: "2026-04-10", title: "🌱 Seed: Cilantro & Parsley (Dir)", category: "gardening" },
  { date: "2026-04-15", title: "🍎 Spray: Dormant Oil (Fruit Trees)", category: "gardening" },
  { date: "2026-04-30", title: "❄️ Last Spring Frost (Safe)", category: "gardening" },
  { date: "2026-05-01", title: "🌽 Seed: Sweet Corn (Direct)", category: "gardening" },
  { date: "2026-05-10", title: "🍅 Transplant: Tomatoes Outdoors", category: "gardening" },
  { date: "2026-05-10", title: "🥒 Seed: Zucchini & Timun (Dir)", category: "gardening" },
  { date: "2026-05-15", title: "🌶️ Plant: Okra & Peppers (Post-Frost)", category: "gardening" },
  { date: "2026-05-25", title: "🍠 Plant: Sweet Potato Slips", category: "gardening" },
  { date: "2026-06-10", title: "🎃 Plant: Pumpkins (Fall)", category: "gardening" },
  { date: "2026-07-15", title: "🥬 Seed: Napa Cabbage (In for Fall)", category: "gardening" },
  { date: "2026-07-20", title: "🌽 Harvest: Sweet Corn Begins", category: "gardening" },
  { date: "2026-08-15", title: "🥬 Transplant: Napa & Daikon", category: "gardening" },
  { date: "2026-09-10", title: "🍎 Harvest: Asian Pears & Apples", category: "gardening" },
  { date: "2026-10-19", title: "❄️ First Fall Frost", category: "gardening" },
  { date: "2026-10-25", title: "🥬 Harvest: Napa Cabbage Peak", category: "gardening" },
  { date: "2026-10-31", title: "🛑 Stop Mowing Lawn (Est)", category: "gardening" },
  { date: "2026-11-15", title: "🧄 Plant: Garlic (for 2027)", category: "gardening" },
  { date: "2026-11-15", title: "🍎 Tree: Wrap Trunks for Winter", category: "gardening" },
];


